import React, { Component } from 'react';
import axios from './axios';
import './Login.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withTranslation } from "react-i18next";

export async function handleLogout(event) {
    event.preventDefault();

    try {
        await axios.post(
            'https://www.hat.sofhare.com/logout/',
            { refresh_token: localStorage.getItem('refresh_token') },
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            }
        );
    } catch (e) {
        console.error("Errore durante il logout:", e);
    } finally {
        localStorage.clear();
        axios.defaults.headers.common['Authorization'] = null;
        toast.success("Logout!", {
            onClose: () => { window.location.href = '/Login'; },
            autoClose: 1000
        });
    }
}

class Login extends Component {


    constructor(props) {
        super(props);
        this.state = {
            user: '',
            password: '',
            showPassword: false,
        };
        this.onChange = this.onChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.togglePasswordVisibility = this.togglePasswordVisibility.bind(this);
    }
    onChange = (e) => this.setState({ [e.target.name]: e.target.value });


    handleSubmit(event) {
        event.preventDefault();
        const { t } = this.props;

        axios.post('https://www.hat.sofhare.com/api/token/',{
            username: this.state.user,
            password: this.state.password,
        } ,{headers:
                        {'Content-Type': 'application/json'}}).then(function (res){
            //console.log('dentro')
            localStorage.setItem('token', res.data.access);
            localStorage.setItem('user', res.config.data);
            localStorage.setItem('refresh_token', res.data.refresh);
            axios.defaults.headers.common['Authorization'] =
                                         `Bearer ${res.data['access']}`;

            window.location.href = '/ves_dashboard'

        }).catch(function (err){
            toast.error(t('pages.toast.ts4'), {autoClose:1000});
        })
    }

    // Toggle password visibility
    togglePasswordVisibility() {
        this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
    }

    render() {
        const { t } = this.props;
        return (
            <div className="main-wrapper-login">
                <div className="tools-wrapperS1-login">
                    <div className="login-block">
                        <h3 className="preview-title">{t('pages.login.tl')} </h3>
                        <form>
                            <div>
                                <label name="user-txt">{t('pages.login.l1')}</label>
                            </div>
                            <div>
                                <input
                                    type="text"
                                    placeholder="Enter user"
                                    name="user"
                                    value={this.state.user}
                                    onChange={this.onChange}
                                />
                            </div>
                            <div>
                                <label name="pw-txt">{t('pages.login.l2')}</label>
                            </div>
                        <div className="password-input-container">
                            <input
                                type={this.state.showPassword ? "text" : "password"} // Toggle between text and password
                                placeholder="Password"
                                name="password"
                                value={this.state.password}
                                onChange={this.onChange}
                            />
                            <button
                                type="button"
                                className="toggle-password-btn"
                                onClick={this.togglePasswordVisibility}
                            >
                                {this.state.showPassword ? <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" >
                                  <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                </svg>
                                 : <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" >
                                  <path strokeLinecap="round" strokeLinejoin="round" d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88" />
                                </svg>
                                }
                            </button>
                        </div>
                            <button
                                variant="primary"
                                type="submit"
                                name="btn-login"
                                onClick={this.handleSubmit}
                                className="btn-block"
                                style={{ maxWidth: '300px' }}
                            >
                                {t('pages.login.l3')}
                            </button>

                            {/* Forgot Password and Create Account links, each on a new line */}
                            <div className="additional-options">
                                <div>
                                    <a href="/Lost_pw" className="forgot-password-link">
                                        {t('pages.login.l4')}
                                    </a>
                                </div>
                                <div>
                                    <p>{t('pages.login.l5')}</p>
                                    <a href="/newuser" className="create-account-link">
                                        {t('pages.login.l6')}
                                    </a>
                                </div>
                            </div>
                        </form>
                    </div>

                </div>
                    
            </div>

        )
    }
}
export default withTranslation()(Login);